import React from 'react';
import TextField from '@material-ui/core/TextField';
export { EntityNamePickerSchema } from './schema.esm.js';

const EntityNamePicker = (props) => {
  const {
    onChange,
    required,
    schema: { title = "Name", description = "Unique name of the component" },
    rawErrors,
    formData,
    uiSchema: { "ui:autofocus": autoFocus },
    idSchema,
    placeholder
  } = props;
  return /* @__PURE__ */ React.createElement(
    TextField,
    {
      id: idSchema?.$id,
      label: title,
      placeholder,
      helperText: description,
      required,
      value: formData ?? "",
      onChange: ({ target: { value } }) => onChange(value),
      margin: "normal",
      error: rawErrors?.length > 0 && !formData,
      inputProps: { autoFocus }
    }
  );
};

export { EntityNamePicker };
//# sourceMappingURL=EntityNamePicker.esm.js.map
